export default __webpack_public_path__ + "static/media/cloud-1.4650219a.png";